import * as React from "react";

export interface MabTracker {
  mabTrack?: () => void;
}

const defaultMabTracker: MabTracker = {
  mabTrack: undefined,
};

export const MabTrackerContext = React.createContext(defaultMabTracker);
MabTrackerContext.displayName = "MabTrackerContext";

export const useMabTrackerContext = (): MabTracker => {
  return React.useContext(MabTrackerContext);
};
